import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import Summary from "../../sections/summary";
import LoginForm from "../../sections/login-form";
import HeroGradient from "../../sections/hero-gradient";
import AccordionWrapper from "../../elements/accordion-wrapper";

import "./style.scss";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { LOGOUT, setUserInfoAction } from "../../redux/actions";
import { becomeAMemberSummary, clearComparisonToolApiBody, setShowChangeMembershipModels } from "../../redux/actions/becomeAMember";

import { canUseDOM, isBizNull } from "../../utils";
import api from "../../utils/api";
import { S_AUTH_TOKEN, webStorage } from "../../utils/webStorage";
import useQuery from "../../utils/useQuery";
import { initialLogic } from "../../services/productService";
import { getSummary } from "../../services/summaryService";
import MembershipModal from "./../MembershipModal";
import { authProvider } from "../../services/authProvider";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import store from "../../redux/store/store";
import InStoreLoginForm from "../../sections/in-store-login-form";
import { clearBillingInfoAction, clearContactInfoAction, clearShippingInfoAction } from "../../redux/actions/gears-checkout";
import { selectComparisonToolApiBody, staffInfoSelector } from "../../selectors/application";
import { creatingClues } from "../../utils/comparisonTool";
import { accountAddInfo } from "../../services/caseInfo";
import useAccountLogin from "../../hooks/useAccountLogin";
let submitting = false;
const PreSalesLogin = ({ rendering, fields, lang, match, summaryCommons, clearComparisonToolApiBody, comparisonToolApiBody, setBecomeAMemberSummary, setUserInfo, logout, clearShippingInfo, clearBillingInfo, clearContactInfo, history, setShowChangeMembershipModels, showModels, page, staffInfo }) => {
  const {
    heroHeadingType,
    heroHeadingBody,
    backgroundImage,
    newUserTitleType,
    newUserTitleBody,
    newUserCTA,
    loginForm,
    inStoreLoginForm,
    defaultRedirect,
    loginSuccessRedirectUrl,
    summary,
    mebershipModalChangeToLevel1,
    mebershipModalChangeToLevel2,
    mebershipModalChangeToLevel3,
    mebershipModalChangeToSameLevel,
    mebershipModalChangeFromLevel3
  } = fields;
  // console.log("inStoreLoginForm", inStoreLoginForm);
  const summaryData = getSummary(summary[0], summaryCommons);

  const query = useQuery();
  const [selectSummary, setSelectSummary] = useState(summaryData);
  const [inStoreMemberNotFound, setInStoreMemberNotFound] = useState(false);
  // const [openResetPassword, setOpenResetPassword] = useState(null);

  const { loginFailed, loginWrongEmailOrPassword, loginNetworkError, loginAccountLock, temporaryLock, login } = useAccountLogin();
  useEffect(() => {
    if (query.action === "logout" || staffInfo) {
      logout();
    }
  }, []);
  useEffect(() => {
    if (canUseDOM()) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    let defaultRedirectHref = defaultRedirect?.value.href ? defaultRedirect.value.href : `/${lang}`;
    if (!query.redirect) {
      history.replace(defaultRedirectHref);
    } else {
      //** Measurements */
      let dataLayer = window.dataLayer || [];
      let _currency = "EUR";
      let _country = lang.indexOf("-") > -1 ? lang.split("-")[1] : "se";
      if (_country === "se") {
        _currency = "SEK";
      }
      let _page = {
        type: page.fields.pageType,
        currency: _currency,
        country: lang
      };
      dataLayer.push({
        event: "virtualPageview",
        virtualPageUrl: history.location.pathname + history.location.search,
        virtualPageTitle: "pre_sales_login_" + summaryCommons.membership,
        page: _page
      });
      initialLogic(lang, summaryCommons).then(payload => {
        if (!isBizNull(payload) && summary[0]) {
          selectSummary.images = payload.image;
          // selectSummary.details.deposit.currency = payload.currency;
          selectSummary.details.deposit.deposit.value = payload.formattedPrice;
          let selectSummary1 = JSON.parse(JSON.stringify(selectSummary));
          setSelectSummary(selectSummary1);
        }
      });
    }
  }, [summaryCommons]);
  // const loginRedirect = () => {
  //   const token = webStorage.get(S_AUTH_TOKEN);
  //   if (query.redirect) {
  //     if (query.redirect.startsWith("https://") || query.redirect.startsWith("http://")) {
  //       global.location.href = `${query.redirect}?token=${token.accessToken}`;
  //     } else {
  //       history.replace(query.redirect);
  //     }
  //   } else if (loginSuccessRedirectUrl.value) {
  //     history.replace(loginSuccessRedirectUrl.value.href);
  //   }
  // };
  const showMembershipModal = newUser => {
    console.log(newUser.membershipCode, summaryCommons.membershipCode);
    if (newUser.membershipCode !== summaryCommons.membershipCode && newUser.membershipCode === "MEMBERSHIP04") {
      setShowChangeMembershipModels({
        ...showModels,
        fromLevel3: true
      });
    } else if (newUser.membershipCode !== summaryCommons.membershipCode && summaryCommons.membershipCode === "MEMBERSHIP02") {
      if (mebershipModalChangeToLevel1 && mebershipModalChangeToLevel1[0] && mebershipModalChangeToLevel1[0].fields) {
        setShowChangeMembershipModels({
          ...showModels,
          level1: true
        });
      }
    } else if (newUser.membershipCode !== summaryCommons.membershipCode && summaryCommons.membershipCode === "MEMBERSHIP03") {
      if (mebershipModalChangeToLevel2 && mebershipModalChangeToLevel2[0] && mebershipModalChangeToLevel2[0].fields) {
        setShowChangeMembershipModels({
          ...showModels,
          level2: true
        });
      }
    } else if (newUser.membershipCode !== summaryCommons.membershipCode && summaryCommons.membershipCode === "MEMBERSHIP04") {
      if (mebershipModalChangeToLevel3 && mebershipModalChangeToLevel3[0] && mebershipModalChangeToLevel3[0].fields) {
        setShowChangeMembershipModels({
          ...showModels,
          level3: true
        });
      }
    } else if (newUser.membershipCode === summaryCommons.membershipCode) {
      setShowChangeMembershipModels({
        ...showModels,
        levelSame: true
      });
    } else {
      accountAddInfo({
        customerNumber: newUser?.customerNumber,
        color: summaryCommons?.color?.preSelectValue?.defaultLanguageValue,
        engine: summaryCommons?.engine?.preSelectValue?.defaultLanguageValue
      });
      if (query.redirect) {
        history.replace(query.redirect);
      } else if (loginSuccessRedirectUrl.value) {
        history.replace(loginSuccessRedirectUrl.value.href);
      }
    }
  };
  const submitLogin = async (evt, data) => {
    const { userInfo } = await login(data.email, data.password);
    if (userInfo) {
      creatingClues(userInfo, summaryCommons?.membershipCode, comparisonToolApiBody).then(res => {
        if (!isBizNull(res)) {
          clearComparisonToolApiBody();
        }
      });
      clearShippingInfo();
      clearBillingInfo();
      clearContactInfo();
      //** Measurements */
      let dataLayer = window.dataLayer || [];
      let membershipLevel = "";
      switch (summaryCommons.membershipCode) {
        case "MEMBERSHIP01":
          membershipLevel = "Level0";
          break;
        case "MEMBERSHIP02":
          membershipLevel = "Level1";
          break;
        case "MEMBERSHIP03":
          membershipLevel = "Level2";
          break;
        case "MEMBERSHIP04":
          membershipLevel = "Level3";
          break;
        default:
          return;
      }
      dataLayer.push({
        event: "accountLogin",
        eventCategory: "account",
        eventAction: "login",
        eventLabel: membershipLevel
      });
      // console.log(query,query.redirect)
      // let level = summaryCommon.membership ? summaryCommon.membership : ""
      showMembershipModal(userInfo);
    }
  };

  const submitLoginInStore = async (evt, data, staffAccountDetails) => {
    if (!submitting) {
      submitting = true;
      setInStoreMemberNotFound(false);
      const { obj } = await api.email.getUser({
        email: data.email
      });
      if (obj) {
        setUserInfo(obj);
        creatingClues(obj, summaryCommons?.membershipCode, comparisonToolApiBody).then(res => {
          if (!isBizNull(res)) {
            clearComparisonToolApiBody();
          }
        });
        /** Measurements */
        let dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "checkoutOption",
          option: "login",
          step: 1
        });
        showMembershipModal(obj);
      } else {
        setInStoreMemberNotFound(true);
      }
      submitting = false;
    }
  };

  let button = JSON.parse(JSON.stringify(newUserCTA.fields));
  if (button && button.link && button.link.value && button.link.value.href && query.redirect) {
    button.link.value.href += `?redirect=${encodeURIComponent(query.redirect)}`;
  }
  const createAccount = {
    heading: { type: newUserTitleType, html: newUserTitleBody },
    //body: newUserBody.value,
    button: {
      ...button
    }
  };
  const summaryProps = {
    ...selectSummary,
    match: match,
    callback: ({ color, engine }) => {
      let becomeAMemberSummary = {
        ...summaryCommons,
        engine: {
          ...summaryCommons.engine,
          preSelectValue: engine
        },
        color: {
          ...summaryCommons.color,
          preSelectValue: color
        }
      };
      setBecomeAMemberSummary(becomeAMemberSummary);
    }
  };

  // console.log("SUMMARY PROPS", summaryProps);
  return (
    <div className="pre-sales-login grid" datasourceid={rendering.dataSource}>
      {canUseDOM() && (
        <AzureAD provider={authProvider} reduxStore={store}>
          {({ accountInfo, authenticationState }) => {
            return (
              <React.Fragment>
                {authenticationState === AuthenticationState.Unauthenticated && (
                  <>
                    <HeroGradient
                      {...{
                        heading: heroHeadingBody,
                        headingType: heroHeadingType,
                        backgroundImage
                      }}
                    />

                    <section className="create-account">
                      <Heading type={createAccount.heading.type} className="title" html={createAccount.heading.html} typographyClass={createAccount.heading.typographyClass ? createAccount.heading.typographyClass : "type-h3"} />
                      <PrimaryButton {...createAccount.button} />
                    </section>
                    {summary[0] && (
                      <div className="summary-container-mobile">
                        <AccordionWrapper heading={summaryProps.text.heading}>
                          <Summary
                            {...{
                              ...summaryProps,
                              text: { ...summaryProps.text, heading: null },
                              match: match
                            }}
                          />
                        </AccordionWrapper>
                      </div>
                    )}

                    <section className="login-container">
                      <LoginForm
                        {...{
                          ...loginForm[0].fields,
                          loginFailed,
                          loginNetworkError,
                          loginAccountLock,
                          temporaryLock,
                          loginWrongEmailOrPassword,
                          lang,
                          match,
                          submitLogin: (evt, data) => submitLogin(evt, data)
                        }}
                      />
                    </section>
                    {summary[0] && (
                      <div className="summary-container">
                        <Summary {...summaryProps} />
                      </div>
                    )}
                  </>
                )}

                {authenticationState === AuthenticationState.Authenticated && (
                  <>
                    <section className="create-account">
                      <Heading type={createAccount.heading.type} className="title" html={createAccount.heading.html} typographyClass={createAccount.heading.typographyClass ? createAccount.heading.typographyClass : "type-h3"} />
                      <PrimaryButton {...createAccount.button} />
                    </section>
                    {inStoreLoginForm && (
                      <InStoreLoginForm
                        {...{
                          ...inStoreLoginForm.fields,
                          loginFailed,
                          loginNetworkError,
                          loginAccountLock,
                          inStoreMemberNotFound,
                          onContinue: (evt, data) => submitLoginInStore(evt, data, accountInfo)
                        }}
                      />
                    )}
                  </>
                )}
              </React.Fragment>
            );
          }}
        </AzureAD>
      )}
      {showModels.level1 && (
        <MembershipModal
          {...{
            ...mebershipModalChangeToLevel1[0].fields,
            lang,
            history,
            selectedLevel: {
              value: summaryCommons.membershipCode
            },
            link: {
              value: {
                url: query.redirect ? query.redirect : loginSuccessRedirectUrl.value.href
              }
            },
            onCloseClicked: () => {
              setShowChangeMembershipModels({
                ...showModels,
                level1: false
              });
            }
          }}
        />
      )}

      {showModels.level2 && (
        <MembershipModal
          {...{
            ...mebershipModalChangeToLevel2[0].fields,
            lang,
            history,
            selectedLevel: {
              value: summaryCommons.membershipCode
            },
            link: {
              value: {
                url: query.redirect ? query.redirect : loginSuccessRedirectUrl.value.href
              }
            },
            onCloseClicked: () => {
              setShowChangeMembershipModels({
                ...showModels,
                level2: false
              });
            }
          }}
        />
      )}
      {showModels.level3 && (
        <MembershipModal
          {...{
            ...mebershipModalChangeToLevel3[0].fields,
            lang,
            history,
            selectedLevel: {
              value: summaryCommons.membershipCode
            },
            becomeAMemberChangelevel: true,
            link: {
              value: {
                url: query.redirect ? query.redirect : loginSuccessRedirectUrl.value.href
              }
            },
            onCloseClicked: () => {
              setShowChangeMembershipModels({
                ...showModels,
                level3: false
              });
            }
          }}
        />
      )}
      {showModels.levelSame && (
        <MembershipModal
          {...{
            ...mebershipModalChangeToSameLevel[0].fields,
            lang,
            history,
            skipSubmit: true,
            selectedLevel: {
              value: summaryCommons.membershipCode
            },
            link: mebershipModalChangeToSameLevel[0].fields.link,
            onCloseClicked: () => {
              setShowChangeMembershipModels({
                ...showModels,
                levelSame: false
              });
            }
          }}
        />
      )}
      {showModels.fromLevel3 && (
        <MembershipModal
          {...{
            ...mebershipModalChangeFromLevel3[0].fields,
            lang,
            history,
            skipSubmit: true,
            selectedLevel: {
              value: summaryCommons.membershipCode
            },
            link: mebershipModalChangeFromLevel3[0].fields.link,
            onCloseClicked: () => {
              setShowChangeMembershipModels({
                ...showModels,
                fromLevel3: false
              });
            }
          }}
        />
      )}
    </div>
  );
};
PreSalesLogin.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    heroHeadingType: PropTypes.object,
    heroHeadingBody: PropTypes.object,
    // summary: PropTypes.object,
    newUserTitleType: PropTypes.object,
    newUserTitleBody: PropTypes.object,
    newUserCTA: PropTypes.object,
    loginForm: PropTypes.object
  })
};

// export default PreSalesLogin;
const mapStateToProps = state => ({
  staffInfo: staffInfoSelector(state),
  summaryCommons: state.becomeAMemberSummary,
  showModels: state.showChangeMembershipModels,
  comparisonToolApiBody: selectComparisonToolApiBody(state)
});
const mapDispatchToProps = dispatch => ({
  setUserInfo: data => {
    dispatch(setUserInfoAction(data));
  },
  logout: () => dispatch({ type: LOGOUT }),
  clearShippingInfo: () => dispatch(clearShippingInfoAction()),
  clearBillingInfo: () => dispatch(clearBillingInfoAction()),
  clearContactInfo: () => dispatch(clearContactInfoAction()),
  setBecomeAMemberSummary: data => {
    dispatch(becomeAMemberSummary(data));
  },
  setShowChangeMembershipModels: data => {
    dispatch(setShowChangeMembershipModels(data));
  },
  clearComparisonToolApiBody: data => {
    dispatch(clearComparisonToolApiBody(data));
  }
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PreSalesLogin));
